
import Card from 'vux/src/components/card/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

import {Api} from "../../utils/api"
import {Fetch} from "../../utils/storage"
import NotFound from '../../components/NotFound'

export default {
name: 'Registration-List',
components: {
Card,
XButton,
Divider,
NotFound
},

created () {
this.fetchRegistrationList()
},

methods: {
async fetchRegistrationList() {
try {
let res = await Api('GetRegistrationList',{
Data:{
UserID:Fetch('ID'),
},
Limit:999,
})
this.RegistrationList = res.data.List || []
}catch(err) {
this.$vux.toast.show({
text: '获取参会人列表失败',
type: 'cancel'
})
}
},
handleRegistrationAdd() {
this.$router.replace('/user/registration/new')
},
handleRegistrationDelete(id) {
let _this = this
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">确认删除该参会人？删除后不可恢复！</span>',
async onConfirm() {
try {
await Api('DeleteRegistration', {}, {}, [{Name: 'ID', Value: id}])
_this.$vux.toast.show({
text: '参会人已删除！',
type: 'text',
width: '3rem'
})
_this.Page = 1
_this.fetchRegistrationList()
} catch (err) {
_this.$vux.toast.show({
text: '参会人删除出错！',
type: 'text',
width: '3rem'
})

}
}
})
},
handleRegistrationUpdate(id) {
this.$router.push(`/user/registration/edit/${id}`)
},
handleRegistrationSetDefault(id) {
let _this = this
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">确认将参会人设为默认？</span>',
async onConfirm() {
try {
await Api('UpdateRegistration', {
ID: id,
Default: true
})
_this.$vux.toast.show({
text: '设置默认参会人成功！',
type: 'text',
width: '3rem'
})
_this.Page = 1
_this.fetchRegistrationList()
} catch (err) {
_this.$vux.toast.show({
text: '设置默认参会人出错！',
type: 'text',
width: '3rem'
})

}
}
})
}
},

data () {
return {
RegistrationList: []
}
}
}
